/* Populated by react-webpack-redux:action */
export const APP_INITIALIZE = "APP_INITIALIZE";

export const COLLAPSE_LICENSE_FORMS_CHANGE = "COLLAPSE_LICENSE_FORMS_CHANGE";

export const FILTER_CHANGE = "FILTER_CHANGE";
export const FILTER_MOUNTED = "FILTER_MOUNTED";
export const FILTER_RESET = "FILTER_RESET";
export const FILTERS_MOUNTED = "FILTERS_MOUNTED";

export const FORM_SUBMIT = "FORM_SUBMIT";

export const KEYWORD_TRIGGERED_BANNER_ERROR = "KEYWORD_TRIGGERED_BANNER_ERROR";
export const KEYWORD_TRIGGERED_BANNER_REQUESTED =
  "KEYWORD_TRIGGERED_BANNER_REQUESTED";
export const KEYWORD_TRIGGERED_BANNER_SUCCESS =
  "KEYWORD_TRIGGERED_BANNER_SUCCESS";

export const QUERY_CHANGE = "QUERY_CHANGE";

export const RANKING_STRATEGY_CHANGE = "RANKING_STRATEGY_CHANGE";

export const RESULT_MORE = "RESULT_MORE";

export const FOCUS_FIRST_NEW_ITEM_DONE = "FOCUS_FIRST_NEW_ITEM_DONE";

export const SORT_OPTIONS_CHANGE = "SORT_OPTIONS_CHANGE";

export const SEARCH_ERROR = "SEARCH_ERROR";
export const SEARCH_REQUESTED = "SEARCH_REQUESTED";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";

export const SUGGESTIONS_ERROR = "SUGGESTIONS_ERROR";
export const SUGGESTIONS_REQUEST = "SUGGESTIONS_REQUEST";
export const SUGGESTIONS_REQUESTED = "SUGGESTIONS_REQUESTED";
export const SUGGESTIONS_SUCCESS = "SUGGESTIONS_SUCCESS";

export const WEBCODE_NORESULT = "WEBCODE_NORESULT";
export const WEBCODE_REQUESTED = "WEBCODE_REQUESTED";
export const WEBCODE_SKIP = "WEBCODE_SKIP";
export const WEBCODE_SUCCESS = "WEBCODE_SUCCESS";
